/**
 * Which links in an in-app feed body stay links (James 2026-10-19, Q24 (b)).
 *
 * An ALLOWLIST, not a list of bad schemes: an href stays a link only when it
 * resolves to
 *   1. this app's own origin (an absolute URL on it, or a relative path), or
 *   2. EXACTLY the Node API origin (compared as a URL origin, never as a
 *      string prefix) with a path of exactly one of {@link SIGNED_API_PATHS},
 *      with any query string.
 * Everything else (another host, a lookalike, userinfo, another port or
 * scheme, `javascript:`, `data:`, `mailto:`, `tel:`, protocol-relative, an
 * unparseable value) is refused, and the caller shows the link's words with
 * no href. Kept free of the stores so it unit-tests with plain values; the
 * call sites pass {@link FeedOrigins}.
 */
/**
 * The only API paths a feed link may open: the signed one-tap responses the
 * backend builds for the coach's in-app cards (morningCheckinLinkToken.ts and
 * weekendAuthLinkToken.ts, both `BASE_URL` + the path + `?token=…`).
 */
export var SIGNED_API_PATHS = [
    '/webhooks/knock/morning-checkin/respond',
    '/webhooks/knock/weekend-auth/respond'
];
var originOf = function (value) {
    try {
        var url = new URL(value);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.origin : null;
    }
    catch (_a) {
        return null;
    }
};
/**
 * The href, resolved against this app, when it may stay a link; else null.
 * The resolved absolute URL is what the caller should use, so a relative
 * path is never read again against some other base.
 */
export function allowedFeedHref(href, origins) {
    var appOrigin = originOf(origins.app);
    if (appOrigin === null || href.trim() === '') {
        return null;
    }
    var url;
    try {
        url = new URL(href, appOrigin);
    }
    catch (_a) {
        return null;
    }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
        return null;
    }
    if (url.username !== '' || url.password !== '') {
        return null;
    }
    if (url.origin === appOrigin) {
        return url.href;
    }
    var apiOrigin = originOf(origins.api);
    if (apiOrigin !== null &&
        url.origin === apiOrigin &&
        SIGNED_API_PATHS.includes(url.pathname)) {
        return url.href;
    }
    return null;
}
